import { useTranslation } from 'react-i18next'

import Logo from '../../../ui/logo/Logo'
import Language from '../../../language/Language'

type FormLayoutProps = {
  eyebrow: string
  title: React.ReactElement
  text: string
  children: React.ReactNode
}

export const FormLayout = (formLayoutProps: FormLayoutProps) => {
  const { t } = useTranslation('auth')

  return (
    <div className="container-fluid g-0 gfly-cont">
      <div className="row g-0 gfly-cont-row flex-column flex-md-row">
        <div className="col-12 col-md-6 gfly-cont-art align-items-md-stretch text-md-start gap-md-0 p-md-5">
          <Logo inverted />

          <div>
            <div className="eyebrow gfly-eyebrow mb-16">
              {formLayoutProps.eyebrow}
            </div>
            <h2 className="display gfly-title-text">
              {formLayoutProps.title}
            </h2>
            <p className="gfly-text mx-md-0">{formLayoutProps.text}</p>
          </div>
          <div className="ph-row gfly-footer justify-content-md-start">
            <Language />
            <span>·</span>
            <a href="/terms">{t('form-footer.terms')}</a>
          </div>
        </div>

        <div className="col-12 col-md-6 gfly-form-cont flex-md-grow-0 p-md-5">
          {formLayoutProps.children}
        </div>
      </div>
    </div>
  )
}
